import { I18n } from './I18n';
export function isYoutubeEnabled() {
    return localStorage.getItem('oebb-yt-videos') ? true : false;
}
export function toggleYoutubeLocalstorage() {
    if (isYoutubeEnabled()) {
        localStorage.removeItem('oebb-yt-videos');
    }
    else {
        localStorage.setItem('oebb-yt-videos', 'true');
    }
}
export function changeDisclaimerBtnText(disclaimerButton, lang) {
    if (!disclaimerButton)
        return;
    const i18n = new I18n(lang);
    if (isYoutubeEnabled()) {
        disclaimerButton.classList.remove('button--primary');
        disclaimerButton.classList.add('button--link');
        disclaimerButton.textContent = i18n.getProperty('video-deactivate', 'YouTube deaktivieren');
    }
    else {
        disclaimerButton.innerHTML = '<span class="ic-play-white"></span> ' + i18n.getProperty('video-activate', 'YouTube aktivieren');
    }
}
export function createDisclaimerBtn() {
    let disclaimerBtn = document.createElement('button');
    disclaimerBtn.classList.add('js-disclaimer-btn');
    disclaimerBtn.classList.add('video__disclaimer-btn');
    disclaimerBtn.classList.add('button');
    disclaimerBtn.classList.add('button--align-right');
    return disclaimerBtn;
}
export function getNextHeadingLevel(tag) {
    const levels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    if (!tag)
        return 'h1';
    const idx = levels.indexOf(tag.toLowerCase());
    if (idx === -1 || idx >= levels.length - 1)
        return 'h6';
    return levels[idx + 1];
}
export function getLastHeadingBeforeElement(element, containerSelector = 'main') {
    const container = document.querySelector(containerSelector);
    if (!container)
        return 'h1';
    const allHeadings = Array.from(container.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    const headings = allHeadings.filter(h => !h.closest('.video__disclaimer, .js-video'));
    let lastHeading = null;
    for (const h of headings) {
        if (h.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) {
            lastHeading = h;
        }
        else {
            break;
        }
    }
    return lastHeading ? lastHeading.tagName.toLowerCase() : 'null';
}
export function createDisclaimerTxt(lang, videoElement, containerSelector) {
    const i18n = new I18n(lang);
    const fragment = document.createDocumentFragment();
    const lastHeading = videoElement ? getLastHeadingBeforeElement(videoElement, containerSelector) : null;
    const nextHeadingTag = getNextHeadingLevel(lastHeading);
    const headline = document.createElement(nextHeadingTag);
    headline.textContent = i18n.getProperty('video-disclaimer-headline', '');
    const paragraph = document.createElement('p');
    paragraph.classList.add('video__disclaimer-txt');
    paragraph.innerHTML = i18n.getProperty('video-disclaimer', '');
    fragment.appendChild(headline);
    fragment.appendChild(paragraph);
    return fragment;
}
